import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

// Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/thank-you",
    name: "thankyou",
    component: () =>
      import(/* webpackChunkName: "thankyou" */ "../views/ThankYouView.vue"),
  },
  {
    path: "/:catchAll(.*)",
    name: "404",
    component: () =>
      import(/* webpackChunkName: "404" */ "../views/404NotFoundView.vue"),
  },
];

const router = new createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
